var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { AccountService } from '@square/dashboard-protos/models/squareup/sfs/external/services/account/account_service';
import Service, { inject as service } from '@ember/service';
import { computed, set } from '@ember/object';
import { v4 as uuid } from 'uuid';
import rpc, { apiHostUrl } from '@banking/api/utils/rpc';
let SfsAccountApi = (_dec = computed('capitalEngineContext.headers'), _class = class SfsAccountApi extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _defineProperty(this, "primaryAccount", void 0);
    _defineProperty(this, "primaryAccountDetails", void 0);
  }
  get client() {
    return AccountService.create(rpc(apiHostUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  createAccount(idempotencyKey, customerId, name, category) {
    return this.client.createAccount({
      idempotencyKey,
      customerId,
      name,
      category
    }).then(({
      account
    }) => {
      if (!account) {
        throw new Error('failed to create account');
      }
      return account;
    });
  }

  // eslint-disable-next-line unicorn/no-object-as-default-parameter
  async retrieveAccount(accountId, {
    refresh
  } = {
    refresh: false
  }) {
    if (!this.primaryAccount || refresh) {
      const {
        account
      } = await this.client.retrieveAccount({
        accountId
      });
      if (account?.isPrimary) {
        set(this, 'primaryAccount', account);
      }
    }

    // Make sure we don't return a nullable account. This should never happen
    // but technically the field on the proto is nullable.
    if (!this.primaryAccount) {
      throw new Error('failed to retrieve account');
    }
    return this.primaryAccount;
  }
  retrieveAccountDetails(accountId) {
    return this.client.retrieveAccountDetails({
      accountId
    }).then(({
      accountDetails
    }) => {
      if (!accountDetails) {
        throw new Error('failed to retrieve account details');
      }
      set(this, 'primaryAccountDetails', accountDetails);
      return accountDetails;
    });
  }
  closeAccount(accountId, closeToAccountId) {
    return this.client.closeAccount({
      accountId,
      closeToAccountId,
      idempotencyKey: uuid()
    });
  }
  updateAccount(accountId, name) {
    return this.client.updateAccount({
      accountId,
      name
    }).then(({
      account
    }) => {
      if (!account) {
        throw new Error('failed to update account');
      }
      return account;
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _class);
export { SfsAccountApi as default };